import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSupplyPurchaseOrders, SupplyPurchaseOrder } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './supplyPurchaseOrdersModuleConfig';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<SupplyPurchaseOrder> useData={useSupplyPurchaseOrders} config={config} />;
};

export default List;
